import Chart from "common/components/Chart/Chart";
import { useWordCloudChart } from "hooks/chart/UseWordCloudChart";
import React, { useEffect } from "react";
import { buildWordCloudSeriesAppearance, getWordCloudAppearance } from "utils/wordCloudAppearance";
import { getWordCloudData } from "utils/wordCloudData";

const WordCloudChart = ({ data, configuration }) => {
    const { options, setOptions, onChartReady } = useWordCloudChart();
    const { colorPalette, minFontSize, maxFontSize, orientation } = getWordCloudAppearance(configuration);

    useEffect(() => {
        setOptions((previous) => ({
            ...previous,
            series: [{
                ...previous.series[0],
                ...buildWordCloudSeriesAppearance({ colorPalette, minFontSize, maxFontSize, orientation }),
                data: Object.entries(getWordCloudData(data).graph).map(([name, weight]) => ({ name, weight })),
            }],
        }));
    }, [data, colorPalette, minFontSize, maxFontSize, orientation, setOptions]);

    return <Chart options={options} onChartReady={onChartReady} />;
};

export default WordCloudChart;
